export default function MaintenancePerformPopupController(
  equipmentData,
  plan,
  $uibModalInstance,
  $scope,
  $state,
  MaintenanceService,
  equipmentRepository
) {
  'ngInject';

  $scope.equipmentData = equipmentData;
  $scope.plan = plan;

  $scope.openStart = function() {
    $scope.startOpened = true;
  };

  $scope.openEnd = function() {
    $scope.endOpened = true;
  };

  $scope.serviceRecord = {};
  $scope.serviceRecord.tags = [];
  $scope.serviceRecord.workOrder = '';
  $scope.serviceRecord.reading = {
    date: new Date()
  };
  $scope.maxDate = new Date();

  $scope.dateType = false;
  $scope.odometerType = false;
  $scope.runhourType = false;
  $scope.submitted = false;

  $scope.cancel = function() {
    $uibModalInstance.dismiss('Cancelled');
  };

  $scope.getFormattedLink = function(link) {
    if (_.startsWith(link, 'https://') || _.startsWith(link, 'http://')) {
      return link;
    }

    return '//' + link;
  };

  $scope.confirm = function() {
    $scope.submitted = true;

    $scope.serviceRecord.planId = $scope.plan.id;
    $scope.serviceRecord.equipmentId = $scope.equipmentData.id;

    if (!$scope.odometerType && $scope.userForm.runhour.$valid && $scope.userForm.workOrder.$valid) {
      $scope.userForm.odometer.$valid = true;
      $scope.userForm.odometer.$invalid = false;
      $scope.userForm.odometer.$pristine = false;
      $scope.userForm.$valid = true;
    }
    if (!$scope.runhourType && $scope.userForm.odometer.$valid && $scope.userForm.workOrder.$valid) {
      $scope.userForm.runhour.$valid = true;
      $scope.userForm.runhour.$invalid = false;
      $scope.userForm.runhour.$pristine = false;
      $scope.userForm.$valid = true;
    }
    if (!$scope.runhourType && !$scope.odometerType && $scope.userForm.workOrder.$valid) {
      $scope.userForm.$valid = true;
    }

    if ($scope.userForm.$valid) {
      $scope.submitting = true;

      MaintenanceService.newServiceRecord($scope.serviceRecord)
        .then(function(response) {
          if (response.status !== 200) {
            return null;
          }

          var tasks = _.map($scope.tasksData, function(t) {
            var inputsAsMap = {};
            if (t.inputs.length > 0) {
              angular.forEach(t.inputs, function(i) {
                if (i.value) {
                  inputsAsMap[i.key] = i.value.toString();
                }
              });
            }
            return {
              id: t.id,
              inputs: inputsAsMap
            };
          });

          $scope.serviceRecord.id = response.data.id;

          return MaintenanceService.completeTasks(response.data.id, tasks);
        })
        .then(function(response) {
          if (response.status === 202) {
            $state.go('maintenance.history-details', {
              id: $scope.serviceRecord.id
            });
            $uibModalInstance.close($scope.serviceRecord.id);
          } else {
            $uibModalInstance.dismiss('Error completing maintenance plan');
          }
        })
        .finally(function() {
          $scope.submitting = false;
        });
    } else {
      $scope.submitted = true;
    }
  };

  $scope.openStart = function() {
    $scope.startOpened = true;
  };

  $scope.statusData = [];

  var getRunhoursVal = function() {
    equipmentRepository.getEquipmentSeries(equipmentData.id).then(
      function(series) {
        var data = series.data;

        for (var i = 0; i < series.data.length; i++) {
          if (series.data[i].last) {
            if (data[i].tags[0] === 'odometer') {
              $scope.serviceRecord.reading.odometer = Math.round(data[i].last.v);
            }
            if (data[i].tags[0] === 'run_time') {
              $scope.serviceRecord.reading.runhour = Math.round(data[i].last.v);
            }
          }
        }
      },
      function(response) {
        console.log('error getting series data');
      }
    );
  };

  var refresh = function() {
    $scope.loading = true;
    MaintenanceService.getPlan($scope.plan.id)
      .then(function(response) {
        $scope.plan.attributes = response.data;

        var recurrence = $scope.plan.attributes.recurrence;

        for (var i = 0; i < recurrence.rules.length; i++) {
          if (recurrence.rules[i].type == 'date') {
            $scope.dateType = true;
          }
          if (recurrence.rules[i].type == 'odometer') {
            $scope.odometerType = true;
          }
          if (recurrence.rules[i].type == 'runhour') {
            $scope.runhourType = true;

            getRunhoursVal();
          }
        }

        return MaintenanceService.getPlanTasks($scope.plan.id);
      })
      .then(
        function(response) {
          $scope.tasksData = response.data;
          return MaintenanceService.getPlan($scope.plan.id);
        },
        function(response) {
          $scope.error = true;
        }
      )
      .then(
        function(response) {
          var planInfo = response.data;
          $scope.maintenancePlanDoucmentLinks = planInfo.documentLinks;
        },
        function(error) {
          $scope.error = true;
        }
      )
      .finally(function(response) {
        $scope.loading = false;
      });
  };

  refresh();
}
